import { ComponentProps } from 'react';
import { ViewStyle } from 'react-native';
import { MentionInput as MentionInputLib } from 'react-native-controlled-mentions';

type InputLibProps = ComponentProps<typeof MentionInputLib>;

export type MentionInputProps = Omit<InputLibProps, 'onChange'> & {
	onChangeText: InputLibProps['onChange'];
	suggestionStyle?: ViewStyle;
};
